import { toTitleCase } from "src/utils/general"
import { CategoricalDistributionCharts } from "../../../types"

export const preparePieChartData = (
	data: CategoricalDistributionCharts[string],
	name: string
): Highcharts.SeriesPieOptions & {
	title: string
} => {
	return {
		type: "pie",
		name: toTitleCase(name),
		data: Object.keys(data.data).map((key) => {
			return {
				name: toTitleCase(key),
				y: data.data[key],
			}
		}),
		title: toTitleCase(name),
	}
}
export const getPieChartOptions = (
	payload: Highcharts.SeriesPieOptions,
	title: string,
	getValue: any
): Highcharts.Options => {
	return {
		chart: {
			plotShadow: false,
			type: "pie",
		},
		title: { text: title, align: "left", style: { fontSize:'1rem',fontWeight: 'bold' } },
		tooltip: {
			useHTML: true,
			headerFormat: "<small>{series.name}</small><br/>",
			pointFormatter: function (this) {
				return `<span style="color:${this.color}">\u25cf</span> <b>${this.options.name}</b>: ${getValue(
					this.percentage
				)}%`
			},
		},
		accessibility: {
			point: {
				valueSuffix: "%",
			},
		},
		credits: {
			enabled: false,
		},
		plotOptions: {
			pie: {
				cursor: "pointer",
				startAngle: 45,
				allowPointSelect: false,
				dataLabels: {
					enabled: true,
					distance: 10,
					formatter: function (this) {
						return `<b>${this.point.name}</b>: ${getValue(
							this.point.percentage
						)}%`
					}
				},
			},
		},
		series: [payload],
	}
}

export const prepareBarChartData = (
	data: CategoricalDistributionCharts[string],
	name: string
): Highcharts.SeriesColumnOptions & {
	title: string
	xAxisData: string[]
} => {
	return {
		type: "column",
		name: toTitleCase(name),
		data: Object.values(data.data),
		xAxisData: Object.keys(data.data),
		title: toTitleCase(name),
	}
}
export const getBarChartOptions = (
	payload: Highcharts.SeriesColumnOptions,
	title: string,
	xAxisData: string[],
	getValue: any
): Highcharts.Options => {
	return {
		chart: {
			plotShadow: false,
			type: "column",
		},
		title: { text: title, align: "left", style: { fontSize:'1rem',fontWeight: 'bold' } },
		xAxis: {
			categories: xAxisData,
			title: {
				text: null,
			},
		},
		tooltip: {
			useHTML: true,
			headerFormat: "<small>{series.name}</small><br/>",
			pointFormatter: function (this) {
				return `<b>${this.category}</b>: ${getValue(this.options.y)}`
			},
		},
		legend: {
			enabled: false,
		},
		yAxis: {
			min: 0,
			title: {
				text: null,
			},
			labels: {
				overflow: "justify",
			},
		},
		credits: {
			enabled: false,
		},
		plotOptions: {
			bar: {
				cursor: "pointer",
				dataLabels: {
					enabled: false,
				},
			},
		},
		series: [payload],
	}
}
